module.exports = __webpack_public_path__ + "media/entry_pass/pin-3e9817bc.jpeg";